import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Offer() {
  return <section id="offer" className="py-24 px-6 bg-teal relative overflow-hidden" data-id="element-138">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-139">
        <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[100%] rounded-full bg-sage blur-3xl" data-id="element-140"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[100%] rounded-full bg-sage blur-3xl" data-id="element-141"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="bg-cream p-8 md:p-12 rounded-3xl shadow-2xl" data-id="element-144">
            <h2 className="text-3xl md:text-4xl text-teal mb-6" data-id="element-145">
              Get the full 7-Day Menopause Inflammation Reset today.
            </h2>

            <p className="text-lg text-charcoal/80 mb-10 leading-relaxed" data-id="element-146">
              Stop suffering through the heat and the pain. Reclaim your nights
              for less than the cost of a single bottle of generic vitamins.
            </p>

            <div className="mb-10 p-6 bg-white rounded-2xl border border-sage/20 inline-block w-full max-w-md" data-id="element-147">
              <p className="text-sm text-sage font-bold tracking-widest uppercase mb-2" data-id="element-148">
                Digital PDF eBook
              </p>
              <p className="text-charcoal/60 mb-4" data-id="element-149">Instant Access</p>
              <div className="text-2xl font-serif text-charcoal/40 line-through mb-1" data-id="element-150">
                $19
              </div>
              <div className="text-5xl font-serif text-coral font-bold mb-2" data-id="element-151">
                $6.39
              </div>
              <p className="text-sm text-teal font-semibold" data-id="element-152">
                Limited-time discount price!
              </p>
            </div>

            <div data-id="element-153">
              <a href="https://vorabalance.com/cart/44846477541445:1" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-154">
                <Button className="w-full md:w-auto text-xl py-5 px-12" data-id="element-155">
                  GET THE 7-DAY RESET NOW
                </Button>
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}